/** @format */

import {ReactNode} from 'react';

import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';

import PlanChart from 'components/charts/PlanChart';

import KpiChartIcon from '../../icons/kpi-chart.svg?react';

import {
  MetricsContainer,
  MetricCard,
  MetricTitle,
  MetricValue,
  ChartContainer,
  ChartTitle,
  ChartSubtitle,
} from './styles';

export interface SegmentItem {
  id: string;
  label: string;
  value: number;
  icon?: ReactNode;
}

interface Props {
  data: SegmentItem[];
  kpiName: 'CPL' | 'ДРР';
  targetValue?: number;
  currentValue?: number;
  forecastValue?: number;
  onSegmentClick?: (segmentId: string) => void;
  isBudgetChart?: boolean;
}

const ForecastChart = ({
  data,
  kpiName,
  targetValue,
  currentValue,
  forecastValue,
  onSegmentClick,
  isBudgetChart = false,
}: Props) => {
  const getKpiSymbol = () => {
    if (isBudgetChart) return '₽';

    switch (kpiName) {
      case 'CPL':
        return '₽';
      case 'ДРР':
        return '%';
      default:
        return '';
    }
  };

  const getSubtitleText = () => {
    if (isBudgetChart) {
      return 'Вклад сегментов в оптимизацию бюджета, ₽';
    } else {
      return `Потенциал сегментов для улучшения, ${getKpiSymbol()}`;
    }
  };

  const getValue = (value?: number) => {
    if (value == null) return '—';
    if (value === 0) return '0';

    return value.toLocaleString('ru-RU', {maximumFractionDigits: 0}) + ' ' + getKpiSymbol();
  };

  return (
    <ChartContainer>
      <ChartTitle>
        {isBudgetChart ? <CurrencyRubleIcon /> : <KpiChartIcon />}
        {isBudgetChart ? 'Бюджет' : kpiName}
      </ChartTitle>
      <MetricsContainer>
        <MetricCard isFirst data-testid='metric-target'>
          <MetricTitle>Цель</MetricTitle>
          <MetricValue>{getValue(targetValue)}</MetricValue>
        </MetricCard>
        <MetricCard data-testid='metric-current'>
          <MetricTitle>Текущий</MetricTitle>
          <MetricValue>{getValue(currentValue)}</MetricValue>
        </MetricCard>
        <MetricCard isLast data-testid='metric-forecast'>
          <MetricTitle>Прогноз ИИ</MetricTitle>
          <MetricValue>{getValue(forecastValue)}</MetricValue>
        </MetricCard>
      </MetricsContainer>
      <ChartSubtitle>{getSubtitleText()}</ChartSubtitle>

      <PlanChart
        data={data}
        onSegmentClick={onSegmentClick}
        valueType={kpiName === 'ДРР' && !isBudgetChart ? 'percent' : 'number'}
      />
    </ChartContainer>
  );
};

export default ForecastChart;
